import { Component, OnInit } from '@angular/core';
import { GlobalFunctionsGui } from 'globales-projekt-angular';

@Component({
  selector: 'app-hilfe',
  templateUrl: './hilfe.component.html',
  styleUrls: ['./hilfe.component.css'],
})
export class HilfeComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {}

  onClickUp() {
    GlobalFunctionsGui.clickUp();
  }

  onClickDown() {
    GlobalFunctionsGui.clickDown();
  }

 
}
